var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkout-container u-pbl"},[_c('router-view'),_c('modals-container',{key:_vm.$route.fullPath})],1)
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }